import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { LicenseNumberDirective } from 'src/app/validations/license-number-validator.directive';
import { MinAmtDirective } from '../validations/min-amt.directive';
import { AlphaCharactersValidatorDirective } from './alpha-characters-validator.directive';
import { AlphaNumericCharactersValidatorDirective  } from '../validations/alpha-numeric-characters-validator.directive';
import { MailAddressValidatorDirective } from '../validations/MailAddressValidatorDirective';
import { PrimaryAndMailingAddressValidatorDirective } from '../validations/PrimaryAndMailingAddressValidator';
import { PastedValidDateDirective } from './pasted-valid-date.directive';
import { DateFormatValidatorDirective } from '../validations/date-format-validator.directive';
import { MinAgeValidatorDirective } from './min-age-validator.directive';
import { CleanUpVinDirective } from './cleanup-vin.directive';
import { VinCheckerDirective } from './vin-checker.directive';
import { PasteNumbersOnlyDirective } from './cleanup-nondigit-character.directive';
import { RemoveWhiteSpaceDirective } from './remove-whitespace.directive';
import { DateMaskDirective } from './date-mask.directive';
import { VinSpecificationsCheckerDirective } from './vin-specifications-checker.directive';
import { ReadOnlyGroupDirective } from './readonly-group.directive';

@NgModule({
    declarations:
        [
            AlphaCharactersValidatorDirective,
            AlphaNumericCharactersValidatorDirective,
            LicenseNumberDirective,
            MinAmtDirective,
            MailAddressValidatorDirective,
            PrimaryAndMailingAddressValidatorDirective,
            DateFormatValidatorDirective,
            PastedValidDateDirective,
            MinAgeValidatorDirective,
            CleanUpVinDirective,
            VinCheckerDirective,
            PasteNumbersOnlyDirective,
            RemoveWhiteSpaceDirective
        ],
    imports:
        [
            CommonModule,
            DateMaskDirective,
            VinSpecificationsCheckerDirective,
            ReadOnlyGroupDirective
        ],
    exports:
        [
            AlphaCharactersValidatorDirective,
            AlphaNumericCharactersValidatorDirective,
            LicenseNumberDirective,
            MinAmtDirective,
            MailAddressValidatorDirective,
            PrimaryAndMailingAddressValidatorDirective,
            DateFormatValidatorDirective,
            PastedValidDateDirective,
            MinAgeValidatorDirective,
            CleanUpVinDirective,
            VinCheckerDirective,
            PasteNumbersOnlyDirective,
            RemoveWhiteSpaceDirective,
            DateMaskDirective,
            VinSpecificationsCheckerDirective,
            ReadOnlyGroupDirective
        ]
})
export class SharedDirectivesModule { }